<template>
  <el-table-column type="index" label="序号" width="60" align="center"
                   v-bind="$attrs" v-on="$listeners" fixed></el-table-column>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
export default {
  components: {},
  extends: BaseVue,
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">

</style>